import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getRbiLoyaltyPointsInfo } from 'selectors/tools';
import isNil from 'lodash/isNil';
import isFunction from 'lodash/isFunction';
import {
  ResultsColumn,
  ResultsColumnHeader,
  Row,
  HeaderRow,
  SubTitleText,
  Spreadsheet,
} from '../../DTInfoWidget.styles';
import { TransactionRow, ItemRow, Count, NoData, CenterPos, DetailsButton } from './DTPointsInfoWidget.styles';
const DTPointsInfoWidget = () => {
  const {
    customerName,
    storeAddress,
    maskedLoyaltyCardId,
    customerCountry,
    pointsToIssueAmount,
    pointsAvailableAmount,
    recentTransactionsList,
  } = useSelector(getRbiLoyaltyPointsInfo);

  const [selectedTransactionId, setSelectedTransactionId] = useState(null);

  const handleChangeSelectedTransactionId = (transactionId) => {
    setSelectedTransactionId(transactionId === selectedTransactionId ? null : transactionId);
  };

  return (
    <Spreadsheet className="fs-block">
      <HeaderRow>
        <ResultsColumnHeader>CUSTOMER NAME</ResultsColumnHeader>
        <ResultsColumnHeader>CARD ID</ResultsColumnHeader>
        <ResultsColumnHeader>CARD BALANCE</ResultsColumnHeader>
      </HeaderRow>
      <Row>
        <ResultsColumn>{customerName}</ResultsColumn>
        <ResultsColumn>{maskedLoyaltyCardId}</ResultsColumn>
        <ResultsColumn>{pointsAvailableAmount}</ResultsColumn>
      </Row>
      <HeaderRow>
        {!!storeAddress && <ResultsColumnHeader>STORE ADDRESS</ResultsColumnHeader>}
        <ResultsColumnHeader>COUNTRY</ResultsColumnHeader>
        {!!pointsToIssueAmount && <ResultsColumnHeader>ISSUING POINTS</ResultsColumnHeader>}
      </HeaderRow>
      <Row>
        {!!storeAddress && <ResultsColumn>{storeAddress}</ResultsColumn>}
        <ResultsColumn>{customerCountry}</ResultsColumn>
        {!!pointsToIssueAmount && <ResultsColumn>{pointsToIssueAmount}</ResultsColumn>}
      </Row>
      {!!recentTransactionsList.length && (
        <>
          <SubTitleText style={{ marginTop: '25px' }}>TRANSACTION HISTORY (15 MOST RECENT)</SubTitleText>
          <HeaderRow>
            <ResultsColumnHeader>DATE</ResultsColumnHeader>
            <ResultsColumnHeader>LOCATION</ResultsColumnHeader>
            <ResultsColumnHeader>TOTAL</ResultsColumnHeader>
            <ResultsColumnHeader>PTS USED</ResultsColumnHeader>
            <ResultsColumnHeader>PTS EARNED</ResultsColumnHeader>
            <ResultsColumnHeader>ROLLS EARNED</ResultsColumnHeader>
            <ResultsColumnHeader>REWARD USED</ResultsColumnHeader>
            <ResultsColumnHeader>
              <CenterPos>DETAILS</CenterPos>
            </ResultsColumnHeader>
          </HeaderRow>
          {recentTransactionsList.map((transaction) => (
            <Transaction
              {...transaction}
              key={transaction.transactionId}
              handleChangeSelectedTransactionId={handleChangeSelectedTransactionId}
              selectedTransactionId={selectedTransactionId}
            />
          ))}
        </>
      )}
    </Spreadsheet>
  );
};

export default DTPointsInfoWidget;

const Transaction = ({
  timestamp,
  location,
  total,
  pointsUsed,
  pointsEarned,
  rollsEarned,
  rewardUsed,
  currency = '',
  appliedOffers = [],
  items = [],
  transactionId,
  scanAndPay,
  selectedTransactionId,
  handleChangeSelectedTransactionId,
}) => {
  const open = transactionId === selectedTransactionId;
  const itemsAvailable = items.length > 0;
  const appliedOffersAvailable = appliedOffers.length > 0;
  const extraFieldsAvailable = !isNil(scanAndPay);
  const detailsAvailable = itemsAvailable || appliedOffersAvailable || extraFieldsAvailable;

  const toggleSelectedTransactionId = () => {
    if (isFunction(handleChangeSelectedTransactionId)) {
      handleChangeSelectedTransactionId(transactionId);
    }
  };

  return (
    <div className="fs-block">
      <Row>
        <ResultsColumn>{timestamp}</ResultsColumn>
        <ResultsColumn>{location}</ResultsColumn>
        <ResultsColumn>
          {currency} {total}
        </ResultsColumn>
        <ResultsColumn>{pointsUsed}</ResultsColumn>
        <ResultsColumn>{pointsEarned}</ResultsColumn>
        <ResultsColumn>{rollsEarned}</ResultsColumn>
        <ResultsColumn>{rewardUsed}</ResultsColumn>
        <ResultsColumn>
          <CenterPos>
            {detailsAvailable ? (
              <DetailsButton open={open} onClick={() => toggleSelectedTransactionId()} />
            ) : (
              <NoData>N/A</NoData>
            )}
          </CenterPos>
        </ResultsColumn>
      </Row>
      {open && extraFieldsAvailable && (
        <TransactionRow>
          <HeaderRow>
            <ResultsColumnHeader>SCAN AND PAY</ResultsColumnHeader>
          </HeaderRow>
          <Row>
            <ResultsColumn>{!isNil(scanAndPay) ? String(scanAndPay) : 'N/A'}</ResultsColumn>
          </Row>
        </TransactionRow>
      )}
      {open && itemsAvailable && (
        <TransactionRow>
          <HeaderRow>
            <ResultsColumnHeader>ITEMS</ResultsColumnHeader>
            <ResultsColumnHeader>PRICE</ResultsColumnHeader>
          </HeaderRow>
          {items.map(({ name, totalPrice }, idx) => (
            <ItemRow key={idx}>
              <ResultsColumn>
                <Count>{idx + 1}:</Count>
                {name}
              </ResultsColumn>
              <ResultsColumn>
                {currency} {totalPrice}
              </ResultsColumn>
            </ItemRow>
          ))}
        </TransactionRow>
      )}
      {open && appliedOffersAvailable && (
        <TransactionRow>
          <HeaderRow>
            <ResultsColumnHeader>APPLIED OFFERS</ResultsColumnHeader>
          </HeaderRow>
          {appliedOffers.map((offer, idx) => (
            <ItemRow key={idx}>
              <ResultsColumn>
                <Count>{idx + 1}:</Count>
                {offer}
              </ResultsColumn>
            </ItemRow>
          ))}
        </TransactionRow>
      )}
    </div>
  );
};
